export default {
  header: {
    projectName: 'Nome do Projeto',
    export: 'Exportar',
    debug: 'Depurar',
    success: 'Sucesso',
    failed: 'Falha',
    generating: 'Gerando vídeo...',
    updateNameFailed: 'Falha ao atualizar nome do projeto',
    menu: 'Menu',
    settings: 'Configurações',
    shortcuts: 'Atalhos de Teclado',
    about: 'Sobre',
    darkMode: 'Modo Escuro',
    lightMode: 'Modo Claro',
    settingsComingSoon: 'Recurso de configurações em breve',
    shortcutsComingSoon: 'Recurso de atalhos de teclado em breve',
    aboutComingSoon: 'Informações sobre em breve',
    language: 'Idioma',
    dimensions: 'Dimensões',
    canvas: 'Tela',
    view: 'Visualizar',
    general: 'Geral'
  },
  menu: {
    media: 'Mídia',
    text: 'Texto'
  },
  loading: {
    core: 'Carregando Núcleo...'
  },
  home: {
    title: 'GeminiXiang Studio',
    version: 'Beta Público',
    betaDisclaimer: 'Versão beta, persistência de dados não garantida',
    newProject: 'Novo Projeto',
    backupFolder: 'Pasta de Backup',
    documentation: 'Documentação',
    recentProjects: 'Projetos Recentes',
    viewAll: 'Ver todos ({count})',
    noProjects: 'Nenhum projeto ainda. Crie seu primeiro projeto para começar!',
    login: 'ENTRAR',
    github: 'GITHUB',
    discord: 'DISCORD',
    blog: 'BLOG',
    projectCreated: 'Projeto Criado',
    projectCreatedDesc: 'Novo projeto criado com sucesso',
    projectDeleted: 'Projeto Excluído',
    projectDeletedDesc: 'Projeto excluído com sucesso',
    deleteConfirmation: 'Tem certeza que deseja excluir este projeto? Esta ação não pode ser desfeita.',
    migrationFailed: 'Falha na Migração',
    migrationFailedDesc: 'Falha ao migrar dados do localStorage',
    loadFailed: 'Falha no Carregamento',
    loadFailedDesc: 'Falha ao carregar projetos',
    creationFailed: 'Falha na Criação',
    creationFailedDesc: 'Falha ao criar novo projeto',
    deletionFailed: 'Falha na Exclusão',
    deletionFailedDesc: 'Falha ao excluir projeto'
  },
  timeline: {
    autoSaveFailed: 'Falha no salvamento automático',
    autoSaveFailedDesc: 'Falha ao salvar o projeto automaticamente',
    loadFailed: 'Falha no Carregamento',
    loadFailedDesc: 'Falha ao carregar projeto. Redirecionando para o início...',
    mainTrack: 'Faixa Principal',
    undo: 'Desfazer',
    redo: 'Refazer',
    split: 'Dividir',
    delete: 'Excluir'
  },
  attributes: {
    properties: 'Propriedades',
    position: 'Posição',
    scale: 'Escala',
    animation: 'Animação',
    basic: 'Básico',
    mute: 'Mudo',
    text: 'Texto',
    fontSize: 'Tamanho da Fonte',
    content: 'Conteúdo',
    fontFamily: 'Família da Fonte',
    direction: 'Direção do Texto',
    color: 'Cor',
    stroke: 'Traço',
    background: 'Fundo',
    video: 'Vídeo',
    rotate: 'Rotacionar',
    backgroundColor: 'Cor de Fundo',
    opacity: 'Opacidade',
    blend: 'Mesclagem',
    filter: 'Filtro',
    effect: 'Efeito',
    transition: 'Transição',
    speed: 'Velocidade',
    volume: 'Volume'
  },
  router: {
    editor: 'Editor de Vídeo',
    preview: 'Pré-visualização',
    storyboard: 'Storyboard - Agente de Vídeo IA'
  },
  placeholder: {
    text: 'Por favor, insira o conteúdo do texto',
    input: 'Por favor, insira'
  },
  error: {
    parseAudio: 'Falha ao analisar áudio',
    parseImage: 'Falha ao analisar imagem',
    parseVideo: 'Falha ao analisar vídeo',
    noProject: 'Por favor, crie ou abra um projeto primeiro',
    invalidFileType: 'Tipo de arquivo inválido'
  },
  media: {
    video: 'Vídeo',
    image: 'Imagem',
    audio: 'Áudio',
    dropToUpload: 'Solte arquivos aqui para enviar'
  },
  common: {
    defaultText: 'Texto Padrão',
    delete: 'Excluir'
  }
};
